import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { MenuSidebarComponent } from './menu-sidebar/menu-sidebar.component';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent } from './datatable/datatable.component';
import { AgGridModule } from 'ag-grid-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActionCellRendererComponent } from './cell-renderers/action-cell-renderer/action-cell-renderer.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { NotificationComponent } from "./header/notification/notification.component";
import { ImageCellRendererComponent } from './image-cell-renderer/image-cell-renderer.component';
import { LoaderComponent } from './loader/loader.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { StatusCellRendererComponent } from './cell-renderers/status-cell-renderer/status-cell-renderer.component';
import { FormTrackerComponent } from './header/form-tracker/form-tracker.component';
import { DirtyCheckComponent } from '../pages/dirty-check/dirty-check.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { AifCellRendererComponent } from './cell-renderers/aif-cell-renderer/aif-cell-renderer.component';

@NgModule({
  declarations: [FooterComponent, HeaderComponent, MenuSidebarComponent,DatatableComponent,AifCellRendererComponent,ActionCellRendererComponent,DirtyCheckComponent,ConfirmationModalComponent,NotificationComponent,ImageCellRendererComponent,LoaderComponent,StatusCellRendererComponent,FormTrackerComponent],
  imports: [CommonModule, NgbModule, RouterModule, AgGridModule, NgbPaginationModule,NgSelectModule, FormsModule,NgxSkeletonLoaderModule,
    MatDialogModule, MatSelectModule, NgxMatSelectSearchModule, ReactiveFormsModule],
  exports: [FooterComponent,  HeaderComponent, MenuSidebarComponent,DatatableComponent, AifCellRendererComponent, ActionCellRendererComponent,ConfirmationModalComponent,DirtyCheckComponent,ImageCellRendererComponent,LoaderComponent,StatusCellRendererComponent],

  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: {
        overlayPanelClass: ''
      }
    }
  ]
})

export class SharedModule {}